import { BUILDER_CATEGORY_OTHERS_ARTICLES } from '@/legacy/config/builder'

export const HIDE_FROM_LIST = { 'data.hideFromList': { $ne: true } }

const COMMON_FIELDS = [
  'id',
  'lastUpdated',
  'createdDate',
  'data.url',
  'data.article.title',
  'data.article.image.small',
  'data.article.image.large',
  'data.article.image.alt',
  'data.author.value.data.name',
  'data.category.value.data',
]

export const PICKED_FIELDS = COMMON_FIELDS.join(',')

export const RELATED_PICKED_FIELDS = [
  ...COMMON_FIELDS,
  'data.product',
  'data.customPublication',
].join(',')

export const MOST_VIEWED_SORT = {
  'data.view': -1,
}

export const LATEST_ARTICLES_SORT = {
  createdDate: -1,
  lastUpdated: -1,
}

export const QUERY_OTHER_ARTICLES = {
  'data.category.id': BUILDER_CATEGORY_OTHERS_ARTICLES,
  ...HIDE_FROM_LIST,
}

export const DEFAULT_ARTICLES_PER_PAGE = 3
